import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: null,
    currentList: undefined
  },
  getters: {},
  mutations: {
    setCurrent (state, contract) {
      state.current = contract
    },
    setCurrentList (state, contractList) {
      state.currentList = contractList
    }
  },
  actions: {
    async addContractChanged ({rootState, dispatch}, {approvedAt, payItems, budget}) {
      await api.addContractChanged(rootState.project.current._id, {approvedAt, payItems, budget})
      await dispatch('project/refreshProject', null, {root: true})
    },
    async addContract ({rootState, dispatch}, bidId) {
      await api.addContractChanged(rootState.project.current._id, {bidId})
      await dispatch('project/refreshProject', null, {root: true})
    },
    async addContractByPayItems ({rootState, dispatch}, payItems) {
      await api.addContractChanged(rootState.project.current._id, {payItems, isXMLPayItems: true})
      await dispatch('project/refreshProject', null, {root: true})
    },
    getContractChanged ({rootState, commit}, _id) {
      return api.getContractChanged(rootState.project.current._id, _id)
    },
    async getContractList ({rootState, commit}) {
      const result = await api.getContracts(rootState.project.current.type === rootState.enumData.projectType.sheet.value ? rootState.project.current.parent : rootState.project.current._id)
      commit('setCurrentList', result)
      return result
    },
    async getNewestPayItems ({rootState}) {
      const payItems = await api.getPayItems(rootState.project.current._id)
      payItems.forEach(payItem => {
        payItem.previous = {...payItem}
      })
      return payItems
    },
    async getPayItemsFromXML ({rootState}, xmlFile) {
      const payItems = await api.convertXMLToPayItems(xmlFile)

      return payItems
    },
    updateContractChanged ({rootState}, {_id, payItems, approvedAt, budget}) {
      return api.updateContractChanged(rootState.project.current._id, _id, {payItems, approvedAt, budget})
    },
    approveContractChanged ({rootState}, {_id, approvedAt}) {
      return api.approveContractChanged(rootState.project.current._id, _id, approvedAt)
    },
    deleteContractChanged ({rootState}, _id) {
      return api.deleteContractChanged(rootState.project.current._id, _id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contract.js